export interface MessagingSharedLocation {
  latitude: number;
  longitude: number;
  accuracy?: number;
  address?: string;
  label: string;
  googleMapsUrl: string;
}

async function getBrowserLocation(): Promise<GeolocationPosition> {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    throw new Error('Location services are not available on this device');
  }

  return new Promise<GeolocationPosition>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    });
  });
}

async function reverseGeocode(latitude: number, longitude: number): Promise<string | undefined> {
  try {
    const response = await fetch(`/api/v1/geocode?lat=${encodeURIComponent(latitude)}&lng=${encodeURIComponent(longitude)}`);
    const result = await response.json().catch(() => ({}));

    if (response.ok && result?.success && typeof result.display_name === 'string') {
      return result.display_name;
    }
  } catch {
    // Ignore reverse-geocode failures and fall back to coordinates.
  }

  return undefined;
}

export async function getMessagingSharedLocation(): Promise<MessagingSharedLocation> {
  const position = await getBrowserLocation();
  const { latitude, longitude, accuracy } = position.coords;
  const address = await reverseGeocode(latitude, longitude);
  const label = address || `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;

  return {
    latitude,
    longitude,
    accuracy,
    address,
    label,
    googleMapsUrl: `https://www.google.com/maps?q=${latitude},${longitude}`,
  };
}